import * as types from 'store/mutation-types'

export default {
  state: {},
  mutations: {
    [types.ROUTE_CHANGED](state, { to, from }) {
      Object.assign(
        state,
        Object.freeze({
          name: to.name,
          path: to.path,
          hash: to.hash,
          query: to.query,
          params: to.params,
          fullPath: to.fullPath,
          meta: to.meta,
          from
        })
      )
    }
  }
}
